export const validateFilters = ({
  reportType,
  rateTypes,
  dateOrder,
  transactionStartDate,
  transactionEndDate,
  applicationStartDate,
  applicationEndDate
}) => {
  // a rate type is required for the summary report
  if (reportType === 'SUMMARY' && rateTypes.length === 0) throw new Error('Please select at least 1 Rate Type');

  if (reportType === 'RECONCILIATION') {
    // transactionStartDate is required for the reconciliation report
    if (!transactionStartDate) throw new Error('A Transaction Start Date must be specified');
  } else {
    // dateOrder is required for the other payment reports
    if (!dateOrder) throw new Error('Please specify a Date Order');

    // either transactionStartDate or applicationStartDate is required for the other payment reports
    if (!applicationStartDate && !transactionStartDate) throw new Error('Please specify either an Application Start Date or a Transaction Start Date');

    // applicationEndDate should be after the applicationStartDate for the other payment reports
    if (applicationStartDate && applicationEndDate) {
      if (applicationStartDate > applicationEndDate) throw new Error('Application End Date must be after the Application Start Date');
    }
  }

  // transactionEndDate should be after the transactionStartDate for all payment reports
  if (transactionStartDate && transactionEndDate) {
    if (transactionStartDate > transactionEndDate) throw new Error('Transaction End Date must be after the Transaction Start Date');
  }

  return true;
};